import useSalonController from '@admin/api/useSalonController'
import Input from '@blocks/Input'
import { notify } from '@helpers'
import React from 'react'
import { useParams } from 'react-router'
import { CellProps } from 'react-table'
import { PAYMENT } from '../config/constants'

export default function PaidStatusCell({ row, value }: Props ) {
    const { id } = useParams<{ id: string }>()
    const controller = useSalonController()
    
    const handleClick = async () => {
        await controller.togglePaid(id, row.original.id)
        notify("The status of a customer has been changed.")    
    }

    return <Input 
        id={`paid-${row.original.id}`} 
        name={`paid-${row.original.id}`} 
        type="checkbox" 
        disabled={value === PAYMENT.manual}
        onClick={handleClick}
        checked={value === PAYMENT.paid || value === PAYMENT.manual} />
}

// TYPES
type Props = React.PropsWithChildren<CellProps<Interfaces.Customer.Includes<"payments">, string>>